<onyx-information-heading [identifierColor]="identifierColor()">
  {{ `${DictionaryCode.ORDER_POINT_STATUS}.${swapPoint().status}` | translate }}
</onyx-information-heading>

<onyx-data-widget
  [headingIcon]="{
    name: icon(),
    size: 20,
    color: complianceColor(),
  }"
  [color]="complianceColor()"
  [showHeadingAddon]="true"
>
  <ng-container heading>
    @if (
      status() === OrderPointStatus.TO_DO &&
      !swapPoint().estimations?.arrivalTime
    ) {
      {{ 'labels.unknownEta' | translate }}
    } @else if (realizationTime(); as realizationTime) {
      {{ realizationLabel() | translate }}
      {{ realizationTime | onyxDate: 'time-date' : { separator: ' · ' } }}
    }
  </ng-container>

  @let deadline = deadlineData().deadline;
  @if (realizationTime(); as realizationTime) {
    <ng-container headingAddon>
      @if (
        [OrderPointStatus.WAITING, OrderPointStatus.IN_PROGRESS].includes(
          status()
        )
      ) {
        {{
          realizationTime
            | diff: commonHelper.now()
            | duration
              : {
                  units: ['h', 'm', 's'],
                  past: true,
                  negativeSign: false,
                  plusSign: false,
                }
        }}
      } @else if (deadline) {
        {{
          deadline
            | diff: realizationTime
            | duration
              : {
                  past: true,
                  negativeSign: true,
                  plusSign: true,
                }
        }}
      }
    </ng-container>
  }

  <p>
    {{ deadlineData().label | translate }}

    @if (deadline) {
      {{ deadline | onyxDate: 'time-date' : { separator: ' · ' } }}
    } @else {
      {{ 'labels.unknownHour' | translate }}
    }
  </p>
</onyx-data-widget>
